<template>
  <div class="flex flex-wrap gap-2 rounded-2xl bg-gray-50 p-2 dark:bg-gray-800/80">
    <button
      v-for="tab in tabs"
      :key="tab.device"
      type="button"
      @click="$emit('update:modelValue', tab.device)"
      :aria-pressed="modelValue === tab.device"
      :class="[
        'inline-flex items-center gap-2 rounded-xl px-4 py-2 text-sm font-semibold transition-all duration-200',
        modelValue === tab.device
          ? 'bg-white text-purple-700 shadow-md ring-1 ring-purple-200 dark:bg-gray-700 dark:text-purple-200 dark:ring-purple-500/40'
          : 'text-gray-600 hover:bg-white hover:text-gray-900 dark:text-gray-300 dark:hover:bg-gray-700 dark:hover:text-white'
      ]"
    >
      <span aria-hidden="true">{{ tab.emoji }}</span>
      <span>{{ tab.shortLabel }}</span>
    </button>
  </div>
</template>

<script setup lang="ts">
import type { DeviceWallpaperTab, DeviceTabOption } from '../../composables/useDeviceWallpaperTabs'

interface Props {
  modelValue: DeviceWallpaperTab
  tabs: DeviceTabOption[]
}

defineProps<Props>()
defineEmits<{
  (e: 'update:modelValue', value: DeviceWallpaperTab): void
}>()
</script>
